import "./NavigationBar.less";

import * as React from "react";

import * as Api from "lib/api";
import { CancellationToken } from "lib/api/base";

import { ContentSection } from "lib/data";
import { IBaseProps } from "lib/data/interfaces";
import { RouteComponentProps } from "react-router";
import { NavigationMenu } from "./components";
import { StateService } from "lib/services";

interface INavigationBarProps extends IBaseProps, RouteComponentProps<any> {
}

interface INavigationBarState {
	navbarClassNameModifier: string;
	title?: string;
	backgroundUrl?: string;
}

export class NavigationBar extends React.Component<INavigationBarProps, INavigationBarState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();

	private sections!: ContentSection[];

	constructor(props: INavigationBarProps) {

		super(props);

		this.state = {
			navbarClassNameModifier: "home-navigation-bar"
		};
	}
	public async componentWillMount() {

		const content = await Api.ContentManagementApi.getHomeContent();

		if (content) {
			this.sections = content.sections;
			StateService.setCancelableState(() => this.setState({ title: content.title, backgroundUrl: content.backgroundURL }), this.apiCancellationToken);
		}
	}

	public async componentWillReceiveProps(_newProps: INavigationBarProps) {
		const content = await Api.ContentManagementApi.getHomeContent();

		if (content) {
			this.sections = content.sections;
			StateService.setCancelableState(() => this.setState({ title: content.title, backgroundUrl: content.backgroundURL }), this.apiCancellationToken);
		}
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public render() {

		// Define Class Name
		const className = "navigationBar" + (this.props.className ? ` ${this.props.className}` : "") + (this.props.location.pathname === "/" ? " home-navigation-bar" : "");

		return (
			<div className={className} >

				<div className="logoWrapper">
					&nbsp;
					{/* <img src="https://rules.wyo.gov/assets/images-custom/wyominglogo-whitea.png" /> */}
				</div>

				<div className="spacer-auto" />
				<NavigationMenu contentSections={this.sections} />
			</div>
		);
	}
}
